import store from 'store'

import Vue from 'vue'
import Vuex from 'vuex'
import { get, isUndefined } from 'lodash'

import chat from './modules/chat'
import chunk from './modules/chunk'
import consts from './modules/consts'
import graph from './modules/graph'
import event from './modules/event'
import lang from './modules/lang'
import notification from './modules/notification'
import rubric from './modules/rubric'
import user from './modules/user'

import APIMock from './../api/mock'
import APIRemote from './../api/remote'
import APILocal from './../api/local'

import * as DB from '../lib/indexedDB'

const SET_PLATFORM = 'SET_PLATFORM'
const SET_PHASE = 'SET_PHASE'
const SET_AGG_METHOD = 'SET_AGG_METHOD'
const SET_VERSION = 'SET_VERSION'
const SET_RESOURCE_ENABLED = 'SET_RESOURCE_ENABLED'

Vue.use(Vuex)

const { db } = DB
window.db = db

const mock = new APIMock()
const remote = new APIRemote()
const local = new APILocal({ db })

const state = {
  provider: 'remote',
  providers: {
    mock,
    remote,
    local
  },
  api: null,
  localStore: store,
  version: null,
  platform: null,
  phase: null,
  aggMethod: null,
  singleTypeResponse: true, // set true to disable 'resource'
  db
}

state.api = state.providers[state.provider]

const getters = {
  api: state => state.api,
  localStore: state => state.localStore,
  version: state => state.version,
  platform: state => state.platform,
  phase: state => state.phase,
  apiProvider: state => state.provider,
  aggMethod: state => state.aggMethod,
  singleTypeResponse: state => state.singleTypeResponse,
  showGoogle: state => {
    return get(state.platform, 'Google OAuth enabled', false)
  },
  isRemote: state => state.provider === 'remote',
  isAzure: state => {
    return get(state.platform, 'API mode', null) === 'Azure'
  },
  isTNEMode: state => {
    return get(state.platform, 'API mode', null) === 'T&E'
  }
}

export default new Vuex.Store({
  state: state,
  getters: getters,
  modules: {
    chat,
    chunk,
    consts,
    event,
    graph,
    lang,
    notification,
    rubric,
    user
  },
  actions: {
    async getVersion(ctx) {
      return state.api.getVersion().then(function(platform) {
        ctx.commit(SET_PLATFORM, platform)
        ctx.commit(SET_PHASE, platform['Current Phase'])
        ctx.commit(SET_AGG_METHOD, platform['Aggregation method'])
        ctx.commit(SET_VERSION, platform.version)
        let isResourceEnabled = platform['Resource enabled']
        if (isUndefined(isResourceEnabled)) {
          isResourceEnabled = false
        }
        ctx.commit(SET_RESOURCE_ENABLED, isResourceEnabled)
      })
    },
    async setDefaultAggMethod(ctx, params) {
      ctx.commit(SET_AGG_METHOD, params.aggMethod)
    }
  },
  mutations: {
    SET_API_PROVIDER(state, provider) {
      let p = state.providers[provider]
      state.provider = provider
      if (p) {
        state.api = p
      }
    },
    SET_VERSION(state, version) {
      state.version = version
    },
    SET_PLATFORM(state, platform) {
      state.platform = platform
    },
    SET_PHASE(state, phase) {
      state.phase = phase
    },
    SET_AGG_METHOD(state, aggMethod) {
      state.aggMethod = aggMethod
    },
    SET_RESOURCE_ENABLED(state, isResourceEnabled) {
      state.singleTypeResponse = !isResourceEnabled
    }
  },
  strict: false // process.env.NODE_ENV !== 'production'
})
